// eslint-disable-next-line functional/no-let
let worker: Nullable<Worker> = null;

export const getWorkerInstance = () => {
  worker ??= new Worker(new URL('./wasmWorker.ts', import.meta.url));

  return worker;
};
